<template>
  <div class="firm-body">
    <!-- 标题  -->
    <p class="title-Individual-center">
      <span>招聘管理</span>
      <i class="el-icon-arrow-right"></i>
      <span class="firm-clickable" @click="$router.push('/Firm/recruitManager')">精英管理</span>
      <i class="el-icon-arrow-right"></i>
      <span>{{ $route.query.name }}</span>
      <i class="el-icon-arrow-right"></i>
      <span>{{ detail.name }}</span>
      <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">信用评价</span>
    </p>
    <div class="box">
      <div class="box-top flex-box">
        <div>
          <span style="font-size: 12px">公司历史信用评价：</span>
          <el-select
            v-model="isIndex"
            placeholder="请选择"
            style="width: 300px"
          >
            <el-option
              v-for="(item, index) in list"
              :key="item.id"
              :label="item.companyName + '——' + item.jobStartTime"
              :value="index"
            >
            </el-option>
          </el-select>
        </div>
        <div class="flex-box" style="cursor: pointer">
          <img
            @click="download(detail.applyForEvaluate[0])"
            style="cursor: pointer"
            src="@/assets/imgs/xiazai@3x.svg"
            alt=""
          />
          <span class="firm-clickable"
            style="font-size: 12px; margin-left: 15px"
            @click="download(detail.applyForEvaluate[0])"
            >下载职场信用评价申请书</span
          >
        </div>
      </div>
      <div class="box-title" style="margin: 20px 0">
        <span>基本信息</span>
        <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
      </div>
      <div class="information">
        <el-row :gutter="20">
          <el-col :span="8"> 员工姓名：{{ detail.name }} </el-col>
          <el-col :span="8"> 身份证号：{{ detail.idNumber }} </el-col>
          <el-col :span="8">
            <div class="flex-box2">
              <div class="flex-box2" style="margin-right: 30px">
                <img src="@/assets/imgs/dianhua-weijiaohuan@3x.svg" alt="" />
                <span style="margin-left: 10px">{{ detail.phone }}</span>
              </div>
              <div class="flex-box2">
                <img src="@/assets/imgs/youxiang@3x.svg" alt="" />
                <span style="margin-left: 10px">{{ detail.mail }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="8"> 性别：{{ detail.sex == 0 ? "女" : "男" }} </el-col>
          <el-col :span="8"> 身份证地址：{{ detail.idAddress }}</el-col>
          <el-col :span="8">
            <span style="margin-right: 30px"
              >所在部门：{{ detail.deptName }}</span
            >
            <span>所在职位：{{ detail.positionName }}</span>
          </el-col>
          <el-col :span="8"> 出生日期：{{ detail.birthday }} </el-col>
          <el-col :span="8"> 现居地址：{{ detail.currentAddress }} </el-col>
          <el-col :span="8">
            在职时间：{{ detail.jobStartTime }} -
            {{ detail.leaveTime }}
          </el-col>
        </el-row>
      </div>
      <div style="display: flex; align-items: center">
        <div class="box-title">
          <span>打分表</span>
          <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
        </div>
        <div style="font-size: 14px; color: #999999; margin-left: 20px">
          （评价人：{{ detail.createByName }}）
        </div>
      </div>
      <div>
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; font-size: 12px"
          :cell-style="{ textAlign: 'center' }"
          :header-cell-style="{
            background: '#409eff ',
            textAlign: 'center',
            color: '#ffffff',
            padding: '3px',
            fontSize: '12px',
            fontWeight: '400',
            height: '45px',
            border: 0,
          }"
          :span-method="arraySpanMethod"
        >
          <el-table-column prop="date" label="评内容" width="120">
          </el-table-column>
          <el-table-column prop="name" label="评价指标" width="120">
          </el-table-column>
          <el-table-column
            prop="address"
            label="指标描述"
            style="text-align: left"
          >
          </el-table-column>
          <el-table-column prop="sum" label="总分值" width="80">
          </el-table-column>
          <el-table-column prop="address" label="评分" width="320">
            <template slot-scope="scope">
              <div class="pf-box" v-if="scope.row.sum == 10">
                <div
                  :class="scope.row.score == 10 ? 'pf-item active' : 'pf-item'"
                >
                  优（10）
                </div>
                <div
                  :class="scope.row.score == 8 ? 'pf-item active' : 'pf-item'"
                >
                  良（8）
                </div>
                <div
                  :class="scope.row.score == 6 ? 'pf-item active' : 'pf-item'"
                >
                  一般（6）
                </div>
                <div
                  :class="scope.row.score == 3 ? 'pf-item active' : 'pf-item'"
                >
                  差（3）
                </div>
              </div>
              <div class="pf-box" v-if="scope.row.sum == 20">
                <div
                  :class="scope.row.score == 20 ? 'pf-item active' : 'pf-item'"
                >
                  优（20）
                </div>
                <div
                  :class="scope.row.score == 16 ? 'pf-item active' : 'pf-item'"
                >
                  良（16）
                </div>
                <div
                  :class="scope.row.score == 12 ? 'pf-item active' : 'pf-item'"
                >
                  一般（12）
                </div>
                <div
                  :class="scope.row.score == 6 ? 'pf-item active' : 'pf-item'"
                >
                  差（6）
                </div>
              </div>
              <span v-if="scope.row.isShow">
                {{ scope.row.score }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div
          style="
            font-size: 12px;
            color: #666;
            text-align: center;
            height: 60px;
            background: #eeeeee;
            border: 1px solid #eeeeee;
          "
        >
          <p style="line-height: 35px">
            优秀：完全胜任岗位要求(95-100分);
            <span style="margin-left: 20px"
              >良好：很好地达到岗位任职要求(80-95分);</span
            >
          </p>
          <p>
            一般：勉强达到岗位任职要求(60-80分);
            <span style="margin-left: 20px"
              >较差：明显不符合岗位任职要求(60 分以下)。</span
            >
          </p>
        </div>
      </div>
      <div class="box-title">
        <span>辅助材料</span>
        <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
      </div>
      <div
        class="flex-box2"
        v-if="
          detail.contractList?.length > 0 ||
          detail.resumeList?.length > 0 ||
          detail.assistantList?.length > 0
        "
      >
        <div
          class="MaterialsDisplay"
          v-if="detail.contractList?.length > 0"
          @click="handelDownload(detail.contractList)"
        >
          <img src="../../../../assets/imgs/wenjian@3x.svg" alt="" />
          <p
            :style="
              detail.contractList != null && detail.contractList != []
                ? ''
                : 'color:#CFCFCF'
            "
          >
            劳动合同
          </p>
        </div>
        <div
          v-if="detail.resumeList?.length > 0"
          class="MaterialsDisplay"
          @click="handelDownload(detail.resumeList)"
        >
          <img src="../../../../assets/imgs/wenjian@3x.svg" alt="" />
          <p
            :style="
              detail.resumeList != null && detail.resumeList != []
                ? ''
                : 'color:#CFCFCF'
            "
          >
            简历
          </p>
        </div>
        <div
          class="Material"
          v-for="(item, index) in detail.assistantList"
          :key="index"
          style="font-size: 12px; margin-right: 30px; cursor: pointer"
          @click="download(item)"
        >
          <img src="@/assets/imgs/wenjian@3x.svg" alt="" style="width: 30px" />
          <div style="text-align: center">{{ item.attaName }}</div>
        </div>
      </div>
      <div v-else class="flex-box2" style="font-size: 14px">--</div>
      <div>
        <div class="box-title">
          <span>意向</span>
          <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
        </div>
        <div>
          <p style="font-size: 12px; color: #333333">
            <span>意向城市：</span>{{ detail.intentionCity || "--" }}
            <span style="margin-left: 40px">意向职位：</span
            >{{ detail.intentionPosition || "--"
            }}<span style="margin-left: 40px">意向行业：</span
            >{{ detail.intentionIndustry || "--" }}
          </p>
        </div>
      </div>
      <div>
        <div class="box-title">
          <span>备注信息</span>
          <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
        </div>
        <div>
          <p style="font-size: 12px; color: #333333">
            {{ detail.remark || "--" }}
          </p>
        </div>
      </div>
      <div class="AddRegion">
        <p>追加内容</p>
      </div>
      <div>
        <div class="box-title">
          <span>追加材料</span>
          <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
        </div>
        <div class="flex-box2" v-if="detail.appendList.length > 0">
          <div
            class="Material"
            v-for="(item, index) in detail.appendList"
            :key="index"
            style="font-size: 12px; margin-right: 30px; cursor: pointer"
            @click="download(item)"
          >
            <img
              src="@/assets/imgs/wenjian@3x.svg"
              alt=""
              style="width: 30px"
            />
            <div style="text-align: center">{{ item.attaName }}</div>
          </div>
        </div>
        <div v-else class="flex-box2" style="font-size: 14px">--</div>
      </div>
      <div>
        <div class="box-title">
          <span>追加备注</span>
          <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
        </div>
        <div>
          <p style="font-size: 12px; color: #333333">
            {{ detail.appendRemark || "--" }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postGetStsDowLoadPath } from "../../../../assets/api/index";

export default {
  data() {
    return {
      info: "",
      list: [],
      detail: "",
      isIndex: undefined,
      tableData: [
        {
          date: "基础能力",
          name: "业务知识",
          address:
            "是否充分具备现任职务所要求的基础知识和专业技能知识，是否具备丰富的本职工作经验，是否能够不断更新自己的专业知识",
          sum: 10,
          score: 8,
        },
        {
          date: "基础能力",
          name: "学习创新",
          address:
            "是否掌握系统的理论知识，能够将工作中的经验进行总结提炼并有所创新，并能够将所学传授他人",
          sum: 10,
          score: 8,
        },
        {
          date: "基础能力",
          name: "执行能力",
          address:
            "是否自觉遵守各项规章制度，是否依照既定的计划、原则和办法执行工作任务，关注细节，有意识地在工作中寻求规律技巧，提升工作效率与水平",
          sum: 10,
          score: 6,
        },
        {
          date: "基础能力",
          name: "协同能力",
          address:
            "是否具有全局意识，能否主动为他人提供帮助，主动配合其他部门或岗位进行相关工作，善于与人沟通，能有效地化解工作中的矛盾",
          sum: 10,
          score: 6,
        },
        {
          date: "工作任务",
          name: "工作效率",
          address:
            "能否在规定时间内较好地完成工作，是否除自觉完成本职工作外，还能承担分外的工作",
          sum: 20,
          score: 6,
        },
        {
          date: "工作任务",
          name: "工作成果",
          address: "能否按照事先拟定计划或目标保质保量地完成工作任务",
          sum: 20,
          score: 20,
        },
        {
          date: "工作态度",
          name: "积极性和责任感",
          address:
            "工作是否积极主动;是否具有较高的责任感;是否严格遵守工作纪律和规章制度。",
          sum: 20,
          score: 16,
        },
        {
          date: "合计",
          name: "合计",
          address: "合计",
          sum: 0,
          score: 0,
          isShow: true,
        },
      ],
    };
  },
  created() {
    this.isIndex = 0;
    let res = JSON.parse(this.$route.query.res);
    this.list = res.data;
    this.detail = this.list[this.isIndex];
    let sum = 0;
    let sum2 = 0;
    this.tableData[this.tableData.length - 1].sum = 0;
    this.tableData[this.tableData.length - 1].score = 0;
    this.tableData.forEach((item) => {
      sum = item.sum + sum;
      sum2 = item.score + sum2;
    });
    this.tableData[this.tableData.length - 1].sum = sum;
    this.tableData[this.tableData.length - 1].score = sum2;
  },
  watch: {
    isIndex(newVal) {
      this.detail = this.list[newVal];
      this.tableData[0].score = this.detail.score.professionalKnowledge;
      this.tableData[1].score = this.detail.score.learningInnovation;
      this.tableData[2].score = this.detail.score.executionAbility;
      this.tableData[3].score = this.detail.score.synergy;
      this.tableData[4].score = this.detail.score.workingEfficiency;
      this.tableData[5].score = this.detail.score.workAchievements;
      this.tableData[6].score = this.detail.score.enthusiasm;
      let sum = 0;
      let sum2 = 0;
      this.tableData[this.tableData.length - 1].sum = 0;
      this.tableData[this.tableData.length - 1].score = 0;
      this.tableData.forEach((item) => {
        sum = item.sum + sum;
        sum2 = item.score + sum2;
      });
      this.tableData[this.tableData.length - 1].sum = sum;
      this.tableData[this.tableData.length - 1].score = sum2;
    },
  },
  methods: {
    // 下载文件
    download(item) {
      postGetStsDowLoadPath(item.docId).then((res) => {
        window.open(res.data, "_blank");
      });
    },
    // 合并表格
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // 针对第一列（columnIndex === 0）
      if (columnIndex === 0) {
        // 前四行合并（rowIndex 0-3）
        if (rowIndex < 4) {
          // 第一行返回合并 4 行
          if (rowIndex === 0) {
            return { rowspan: 4, colspan: 1 };
          } else {
            // 后续行隐藏
            return { rowspan: 0, colspan: 0 };
          }
        } else if (rowIndex < 6) {
          // 第五行单独显示
          if (rowIndex === 4) {
            return { rowspan: 2, colspan: 1 };
          } else {
            // 后续行隐藏
            return { rowspan: 0, colspan: 0 };
          }
        }
      }
      if (rowIndex === 7) {
        if (columnIndex < 3) {
          // 第一行返回合并 4 行
          if (columnIndex === 0) {
            return { rowspan: 1, colspan: 3 };
          } else {
            // 后续行隐藏
            return { rowspan: 0, colspan: 0 };
          }
        } else {
          return { rowspan: 1, colspan: 1 };
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
// 追加
.AddRegion {
  width: 100%;
  height: 40px;
  display: flex;
  margin-top: 50px;
  p {
    width: 300px;
    height: 40px;
    background: #409eff ;
    border-radius: 10px;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    margin: auto;
  }
}
.flex-box2 {
  .Material {
    width: 80px;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    img {
      margin: auto;
    }
    div {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-top: 5px;
    }
  }
}
.firm-body {
  .box {
    width: 1200px;
    box-sizing: border-box;
    overflow-y: auto;
    margin-top: 20px;
    padding: 10px 30px;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 15px;

    .box-title {
      width: 80px;
      height: 60px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      span {
        font-size: 16px;
        font-weight: 500;
      }

      img {
        position: absolute;
        bottom: 10px;
        left: 0px;
      }
    }

    .information {
      height: 130px;
      background: #ffffff;
      border: 1px solid #eeeeee;
      border-radius: 5px;
      padding: 20px 30px;
      font-size: 12px;
      box-sizing: border-box;
    }

    .pf-box {
      display: flex;
      align-items: center;
      width: 300px;
      box-sizing: border-box;
      border: 1px solid #409eff ;
      border-radius: 15px;
      overflow: hidden;
      margin: 0 auto;

      .pf-item {
        width: 25%;
        border-right: 1px solid #409eff ;
        text-align: center;
      }

      .pf-item:last-child {
        border-right: 0;
      }

      .active {
        background-color: #409eff ;
        color: #fff;
      }
    }
  }
}

.el-col {
  margin-bottom: 18px;
}
</style>
